import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { useMemo, useState } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { API_DATE_FORMAT } from '@utils/date.utils'

import { IntroducingBrokerPerformanceChartDetailDto } from '@model/IntroducingBrokerPerformance'

import { defaultDateRange } from '../constants/performance'

interface UseIBPerformanceValue {
  data: IntroducingBrokerPerformanceChartDetailDto[]
  isLoading: boolean
  dateRange: [Date, Date]
  setDateRange: (dateRange: [Date, Date]) => void
}

export const useIBPerformance = (): UseIBPerformanceValue => {
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()

  const [dateRange, setDateRange] = useState<[Date, Date]>(defaultDateRange)

  const [from, to] = useMemo<[string, string]>(() => {
    return [format(dateRange[0], API_DATE_FORMAT), format(dateRange[1], API_DATE_FORMAT)]
  }, [dateRange])

  const ibId = account?.clientIntroducingBroker?.id

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.ib.performance(ibId, from, to),
    queryFn: () =>
      apiClient.getIBPerformance({
        id: ibId!,
        from,
        to,
      }),
    enabled: !!ibId,
  })

  return {
    data: data || [],
    isLoading,
    dateRange,
    setDateRange,
  }
}
